/**
 * CCM care plan — disease packs (arrhythmia and others). Not used for RPM.
 */
import React, { forwardRef } from 'react';
import DiseaseCarePlanWorkspace from './DiseaseCarePlan/DiseaseCarePlanWorkspace';

const CarePlanPanel = forwardRef(({
  enrollmentId,
  patient,
  readOnly = false,
  onBillingRefresh,
  onPlansChange,
}, ref) => (
  <DiseaseCarePlanWorkspace
    ref={ref}
    program="CCM"
    enrollmentId={String(enrollmentId || '')}
    patient={patient}
    readOnly={readOnly}
    onBillingRefresh={onBillingRefresh}
    onPlansChange={onPlansChange}
  />
));

export default CarePlanPanel;
